import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { ElxFilter, ElxTable, FilterOptionPillMode, } from "@elixir/components";
import { Label, SelectionMode, Spinner, SpinnerSize, Stack, } from "@fluentui/react";
import "./CustomerSearch.css";
import { useCustomerDataDispatch, useCustomerDataState, } from "../../reducers/CustomerSearchContext/CustomerSearchContextProvider";
import { GetCountryDetailAsDropdownOption } from "../../library/utilities/GetDropdownOption";
import SearchTags from "../SearchWithTagsAndOptions/SearchTags";
import { useCommercialContextState } from "../../reducers/CommercialContext/CommercialContextProvider";
import { SearchType } from "../../models";
const CustomerSearch = ({ children, customerSearchData, customerDataResultDispatch, cancelDispatch, }) => {
    var _a, _b;
    const [selections, setSelections] = React.useState([]);
    const [displayCustomerResults, setDisplayCustomerResults] = React.useState([]);
    const CustomerDataState = useCustomerDataState();
    const CustomerDataDispatch = useCustomerDataDispatch();
    const [customerResults, setCustomerResults] = React.useState(CustomerDataState.CustomerData);
    const commercialContextState = useCommercialContextState();
    const midStack = { childrenGap: 5 };
    const [selectedTags, setSelectedTags] = useState([]);
    const columns = [
        {
            key: "column0",
            name: "TP ID #",
            fieldName: "tpid",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column1",
            name: "MS Sales ID",
            fieldName: "msSalesID",
            minWidth: 160,
            maxWidth: 160,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column2",
            name: "Account #",
            fieldName: "accountNumber",
            minWidth: 160,
            maxWidth: 160,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column3",
            name: "Company Name",
            fieldName: "companyName",
            minWidth: 180,
            maxWidth: 180,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column4",
            name: "Subsidiary",
            fieldName: "subsidiary",
            minWidth: 160,
            maxWidth: 160,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column5",
            name: "Sales Region",
            fieldName: "salesRegion",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            isMultiline: true,
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column6",
            name: "ATU Group Name",
            fieldName: "atuGroupName",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isMultiline: true,
            onRender: (item) => {
                var _a;
                if (((_a = item.atuGroupName) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase()) === "UNDEFINED")
                    return "";
                else
                    return item.atuGroupName || "";
            },
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column7",
            name: "ATU Manager Alias",
            fieldName: "atuManagerAlias",
            minWidth: 200,
            maxWidth: 200,
            isMultiline: true,
            isResizable: true,
            onRender: (item) => {
                var _a;
                if (((_a = item.atuManagerAlias) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase()) === "UNDEFINED")
                    return "";
                else
                    return item.atuManagerAlias || "";
            },
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column8",
            name: "ATU Account Executive Alias",
            fieldName: "atuAccountExecutiveAlias",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isMultiline: true,
            onRender: (item) => {
                var _a;
                if (((_a = item.atuAccountExecutiveAlias) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase()) === "UNDEFINED") {
                    return "";
                }
                else
                    return item.atuAccountExecutiveAlias || "";
            },
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column9",
            name: "Segment",
            fieldName: "segment",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isMultiline: true,
            onRender: (item) => {
                var _a;
                if (((_a = item.segment) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase()) === "UNDEFINED")
                    return "";
                else
                    return item.segment || "";
            },
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
        {
            key: "column10",
            name: "Sub Segment",
            fieldName: "subSegment",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isMultiline: true,
            onRender: (item) => {
                var _a;
                if (((_a = item.subSegment) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase()) === "UNDEFINED")
                    return "";
                else
                    return item.subSegment || "";
            },
            onRenderHeader: (props) => {
                return _jsx("strong", { children: props === null || props === void 0 ? void 0 : props.column.name });
            },
        },
    ];
    const filterOptions = [
        {
            pillMode: FilterOptionPillMode.Static,
            field: "tpid",
            label: "TP ID #",
            values: Array.from(new Set(customerResults.map((item) => item.tpid || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "msSalesID",
            label: "MS Sales ID",
            values: Array.from(new Set(customerResults.map((item) => {
                return item.msSalesID || "";
            }))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "accountNumber",
            label: "Account #",
            values: Array.from(new Set(customerResults.map((item) => item.accountNumber || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "companyName",
            label: "Company Name",
            values: Array.from(new Set(customerResults.map((item) => item.companyName || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "subsidiary",
            label: "Subsidiary",
            values: Array.from(new Set(customerResults.map((item) => item.subsidiary || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "salesRegion",
            label: "Sales Region",
            values: Array.from(new Set(customerResults.map((item) => item.salesRegion || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "atuGroupName",
            label: "ATU GroupName",
            values: Array.from(new Set(customerResults.map((item) => item.atuGroupName || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "atuManagerAlias",
            label: "ATU ManagerAlias",
            values: Array.from(new Set(customerResults.map((item) => item.atuManagerAlias || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "atuAccountExecutiveAlias",
            label: "ATU Account ExecutiveAlias",
            values: Array.from(new Set(customerResults.map((item) => item.atuAccountExecutiveAlias || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "segment",
            label: "Segment",
            values: Array.from(new Set(customerResults.map((item) => item.segment || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "subSegment",
            label: "Sub Segment",
            values: Array.from(new Set(customerResults.map((item) => item.subSegment || ""))),
            multiselect: true,
        },
    ];
    const validateSelections = (selections, cusObject) => {
        return ((selections === null || selections === void 0 ? void 0 : selections.length) == 0 ||
            (selections === null || selections === void 0 ? void 0 : selections.every((criteria) => {
                if (criteria.field == "tpid" && criteria.values !== undefined)
                    return criteria.values.includes(cusObject.tpid || "undefined");
                else if (criteria.field == "accountNumber" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.accountNumber || "undefined");
                else if (criteria.field == "atuAccountExecutiveAlias" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.atuAccountExecutiveAlias || "undefined");
                else if (criteria.field == "companyName" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.companyName || "undefined");
                else if (criteria.field == "msSalesID" && criteria.values !== undefined)
                    return criteria.values.includes(cusObject.msSalesID || "undefined");
                else if (criteria.field == "segment" && criteria.values !== undefined)
                    return criteria.values.includes(cusObject.segment || "undefined");
                else if (criteria.field == "subSegment" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.subSegment || "undefined");
                else if (criteria.field == "subsidiary" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.subsidiary || "undefined");
                else if (criteria.field == "atuGroupName" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.atuGroupName || "undefined");
                else if (criteria.field == "salesRegion" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.salesRegion || "undefined");
                else if (criteria.field == "atuManagerAlias" &&
                    criteria.values !== undefined)
                    return criteria.values.includes(cusObject.atuManagerAlias || "undefined");
            })));
    };
    useEffect(() => {
        setDisplayCustomerResults(customerResults);
    }, []);
    useEffect(() => {
        setDisplayCustomerResults(CustomerDataState.CustomerData);
        setCustomerResults(CustomerDataState.CustomerData);
    }, [CustomerDataState.CustomerData]);
    useEffect(() => {
        const searchedobj = customerResults.filter((cusObject) => {
            return (((customerSearchData === null || customerSearchData === void 0 ? void 0 : customerSearchData.trim().length) == 0 ||
                Object.values(cusObject).some((es) => (es === null || es === void 0 ? void 0 : es.toLowerCase().indexOf(customerSearchData === null || customerSearchData === void 0 ? void 0 : customerSearchData.toLowerCase())) !=
                    -1)) &&
                validateSelections(selections, cusObject));
        });
        setDisplayCustomerResults(searchedobj);
    }, [selections, customerSearchData]);
    const onSearchClick = (tags) => {
        //call action
        setSelectedTags(tags);
        if (tags && tags.length > 0) {
            const salesAccountRequest = {
                IsTop200SalesAccountsWithoutSearch: false,
                IsAllBySearchCriteria: false,
            };
            tags.forEach((tag) => {
                if (tag.key.toString() == "TopParentIdNumber")
                    salesAccountRequest.TPId = tag.text.toString();
                if (tag.key.toString() == "AccountName")
                    salesAccountRequest.AccountName = tag.text.toString();
                if (tag.key.toString() == "AccountManagerAlias")
                    salesAccountRequest.AccountManagerAlias = tag.text.toString();
                if (tag.key.toString() == "CountryName")
                    salesAccountRequest.Country = tag.text.toString();
                if (tag.key.toString() == "SalesAccountNumber")
                    salesAccountRequest.AccountNumber = tag.text.toString();
                if (tag.key.toString() == "MSSalesID")
                    salesAccountRequest.MSSalesID = tag.text.toString();
            });
            CustomerDataDispatch.GetCustomerDataCollection(salesAccountRequest);
        }
    };
    const getCountryOptions = useMemo(() => {
        var _a;
        return GetCountryDetailAsDropdownOption((_a = commercialContextState.CommercialContext.CommercialMetadata) === null || _a === void 0 ? void 0 : _a.countries);
    }, [(_a = commercialContextState.CommercialContext.CommercialMetadata) === null || _a === void 0 ? void 0 : _a.countries]);
    return (_jsxs(Stack, Object.assign({ className: "customerResults" }, { children: [_jsx(Stack.Item, Object.assign({ tokens: midStack }, { children: _jsx("div", Object.assign({ className: "closeModelCustomer" }, { children: children })) })), _jsx(Stack.Item, { children: _jsx("div", Object.assign({ style: { paddingLeft: 10 } }, { children: _jsx("h1", Object.assign({ id: "customerSearchHeading" }, { children: "Search Customers" })) })) }), _jsx(Stack.Item, { children: _jsx("div", Object.assign({ className: "customerSearchPanel" }, { children: _jsx(SearchTags, { initialTags: selectedTags, onSearch: onSearchClick, countriesOptions: getCountryOptions, searchType: SearchType.Customer }) })) }), _jsx(Stack.Item, Object.assign({ styles: { root: { paddingLeft: "10px" } } }, { children: displayCustomerResults.length == 0 &&
                    selectedTags &&
                    selectedTags.length == 0 && (_jsx(Label, { children: "Please search by the fields." })) })), _jsx(Stack.Item, { children: (CustomerDataState === null || CustomerDataState === void 0 ? void 0 : CustomerDataState.InProgress) ? _jsx(Spinner, { size: SpinnerSize.large }) : _jsx(_Fragment, {}) }), _jsxs(Stack.Item, Object.assign({ styles: { root: { paddingLeft: "10px" } } }, { children: [(CustomerDataState === null || CustomerDataState === void 0 ? void 0 : CustomerDataState.InProgress) == 0 &&
                        displayCustomerResults.length == 0 &&
                        CustomerDataState.CustomerData.length == 0 && (_jsx(Label, { children: "No records found for the search criteria." })), displayCustomerResults.length > 0 && (_jsx(Label, { children: "Only Top 200 records are displayed. Please refine your search to find other records." })), (((CustomerDataState === null || CustomerDataState === void 0 ? void 0 : CustomerDataState.CustomerData) &&
                        ((_b = CustomerDataState.CustomerData) === null || _b === void 0 ? void 0 : _b.length) > 0) ||
                        displayCustomerResults.length > 0) && (_jsx(ElxFilter, { options: filterOptions, styles: { root: { width: "100%", maxWidth: 800, minWidth: 0 } }, selections: selections, onChange: setSelections }))] })), _jsx(Stack.Item, Object.assign({ tokens: midStack, styles: {
                    root: {
                        width: "100%",
                        minWidth: 0,
                        maxWidth: "100%",
                        minHeight: "200px",
                        maxHeight: "300px",
                    },
                } }, { children: displayCustomerResults.length > 0 && (_jsx("div", Object.assign({ className: "tableResultsViewport", role: "region", "aria-labelledby": "customerSearchHeading", tabIndex: 0 }, { children: _jsx(ElxTable, { "data-testid": "customerslist", className: "customersList", selectionMode: SelectionMode.none, items: displayCustomerResults, columns: columns, onItemInvoked: (item) => {
                            customerDataResultDispatch({
                                customerData: item,
                            });
                            cancelDispatch(false);
                        }, stickyHeader: true, styles: { root: { overflowY: "auto" } } }) }))) }))] })));
};
export default CustomerSearch;
